import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthContext } from "./context/auth";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthContext>
      <App />
      <ToastContainer hideProgressBar newestOnTop />
    </AuthContext>
  </React.StrictMode>
);
